export type ReadonlyFormErrors = Readonly<Record<string, string>>

export class FormError extends Error {
  formErrors: ReadonlyFormErrors

  constructor(formErrors: ReadonlyFormErrors) {
    super('Validation error')
    this.formErrors = formErrors
  }
}
